/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';

import {
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaPodcast,
  FaYoutube,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
} from 'react-icons/fa';
const Footer = () => {
  return (
    <footer
      sx={{
        bg: '#314e4c',
      }}
    >

      <div
        sx={{
          maxWidth: ' 1400px',
          mx: 'auto',
          display: 'flex',
          gap: '1.5rem',
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          padding: '4rem 2rem'
        }}
      >
        <div sx={{
          display: 'flex', flexDirection: 'column', gap: '0.5rem'
        }}>
          <div sx={{ maxWidth: '164px', height: 'auto', }}>
            <Link to="/">
              <img src="/images/logo_white.png" alt="" width="164px" />
            </Link>
          </div>
        </div>

        <div sx={{
          display: 'flex', flexDirection: 'column', gap: '0.5rem'
        }}>
          <div sx={{ maxWidth: '164px', height: 'auto', }}>
            <Link to="https://www.fertiliti.io/">
              <img src="/images/fertiliti-brandmark-design.png" alt="" width="164px" />
            </Link>
          </div>
          <p>
            <a sx={{
              color: '#FFFFFF',
              '&:hover': {
                textDecoration: 'underline',
              },
            }} href='https://www.fertiliti.io/'>Partner Organization</a>
          </p>
        </div>

        <div>
          <p
            sx={{
              fontSize: '1rem',
              color: '#FFFFFF',
              display: 'flex',
              gap: '0.5rem',
              alignItems: 'baseline',
              svg: {
                fontSize: '0.875em',
              },
            }}
          >
            <FaMapMarkerAlt /> National Embryo Donation Center
            <br /> 10700 Virginia Pine Way Ste# 202 Knoxville
            <br /> TN 37932
          </p>
        </div>
        <div sx={{ maxWidth: '400px' }}>
          <p
            sx={{
              fontSize: '1rem',
              color: '#FFFFFF',
              display: 'flex',
              gap: '0.5rem',
              alignItems: 'flex-start',
            }}
          >
            <FaPhone /> Phone: 865-777-2013 <br />
            Fax: 865-777-2016 <br />
            Toll-Free: 866-585-8549
          </p>
        </div>
      </div>

      <div sx={{ bg: '#629b98', px: '2rem' }}>
        <div
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            margin: '0 auto',
            maxWidth: ' 1400px',
            justifyContent: 'space-between',
          }}
        >
          <p
            sx={{
              fontSize: '14px',
              py: '0.5rem',
              color: '#FFFFFF',
              a: {
                textDecoration: 'underline',
                color: '#fff',
              },
            }}
          >
            © 2022 National Embryo Donation Center. <Link to="/privacy-policy">Privacy Policy</Link>
            . All rights reserved.
          </p>
          <div
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '0.25rem',
              maxWidth: ' 1400px',
              height: '50px',
              paddingRight: '2rem',
              a: {
                color: '#fff',
                p: '0.5rem',

                '&:hover': {
                  color: '#F7A496',
                },
              },
            }}
          >
            <a
              href="http://www.linkedin.com/company/national-embryo-donation-center"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Linkedin"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="http://www.twitter.com/embryodonation"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="http://www.facebook.com/embryodonation"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="http://www.youtube.com/NEDCKnoxville"
              target="_blank"
              rel="noopener noreferrer"
              title="Watch us on Youtube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.instagram.com/nedcknoxtn/"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.podomatic.com/podcasts/mmellinger"
              target="_blank"
              rel="noopener noreferrer"
              title="Listen to our Podcast"
            >
              <FaPodcast />
            </a>
          </div>
        </div>
      </div>
    </footer >
  );
};

export default Footer;
